import { SDKManager } from '../libs/sdkManager';
import App from '../main';

export default class Game extends Phaser.Scene {

    constructor() {
        super('Game');
    }

    public static instance: Game = null;

    init(data: any) {
        Game.instance = this;
    }

    private loadingScreen: any = null; 
    preload() {
        App.SDK.onGameLoad();
        this.loadingScreen = document.getElementById('loading-screen');
        let loaderText = document.getElementById('loader-text');
        let loaderBar = document.getElementById('loader-bar');

        let item = document.getElementById('item');

        this.loadingScreen.classList.remove('hide');

        this.load.on('progress',  (value) => {
            let percent = Math.floor((value * 200))// + "%"
            loaderBar.style.width = percent.toString();
            // loaderText.innerText = percent.toString();
            App.SDK.onGameLoading(percent);
        });

        this.load.on('fileprogress',  (file) => {
            item.innerText = "Loading...";//file.src;
        });

        this.load.on('complete',  () => {
            Game.instance.proceedLoadStage();
        }, this);

        this.loadSprites();
        this.loadAudio()

        console.log('Loaded all the assets');
    }

    private loadSprites() {
        this.load.image('logo', 'Sprites/hammerplay-logo-flat.png');
        this.load.image('laser', 'Sprites/laser.png');
        this.load.image('background-01', 'Sprites/background-01.png');
        this.load.image('BG_Gradients', 'Sprites/BG_Gradients.png');
        this.load.unityAtlas('BG_Patterns_0', 'Sprites/BG_Patterns_0.png', 'Sprites/BG_Patterns_0.png.meta');
        this.load.unityAtlas('bullet', 'Sprites/bullet.png', 'Sprites/bullet.png.meta');
        this.load.image('NextButton', 'Sprites/next-button.png');
        this.load.image('Life', 'Sprites/life-heart.png');
        this.load.image('Dead', 'Sprites/life-heart-outline.png');
        this.load.image('GameLogo', 'Sprites/game-logo.png');
        this.load.image('Character_Dead0', 'Sprites/Character_Dead.png');
        this.load.image('Character_Dead1', 'Sprites/Character_Dead_1.png');
        this.load.image('Character_Dead2', 'Sprites/Character_Dead_2.png');
        this.load.image('Character_Dead3', 'Sprites/Character_Dead_3.png');
        this.load.image('Character_Dead4', 'Sprites/Character_Dead_4.png');
        this.load.image('Character_Dead5', 'Sprites/Character_Dead_5.png');
        this.load.image('Character_Dead6', 'Sprites/Character_Dead_6.png');
        this.load.image('Character_Dead7', 'Sprites/Character_Dead_7.png');
        this.load.image('Character_Dead8', 'Sprites/Character_Dead_8.png');
        this.load.image('Character_Dead9', 'Sprites/Character_Dead_9.png');
        this.load.unityAtlas('Character_1', 'Sprites/Character_1.png', 'Sprites/Character_1.png.meta');
        this.load.unityAtlas('Characters_2', 'Sprites/Characters_2.png', 'Sprites/Characters_2.png.meta');
        this.load.unityAtlas('Characters_3', 'Sprites/Characters_3.png', 'Sprites/Characters_3.png.meta');
        this.load.image('english', 'Sprites/english.png');
        this.load.image('french', 'Sprites/french.png');
        this.load.image('spanish', 'Sprites/spanish.png');
        this.load.unityAtlas('Clouds_2', 'Sprites/Clouds_2.png', 'Sprites/Clouds_2.png.meta');
        this.load.unityAtlas('explosion', 'Sprites/explosion.png', 'Sprites/explosion.png.meta');
        this.load.image('Glow', 'Sprites/Glow.png');
        this.load.atlas('hand', 'Sprites/hand.png', 'Sprites/hand.json');
        this.load.unityAtlas('Platform', 'Sprites/Platform.png', 'Sprites/Platform.png.meta');
        this.load.unityAtlas('Platforms_1', 'Sprites/Platforms_1.png', 'Sprites/Platforms_1.png.meta');
        this.load.unityAtlas('Platforms_2', 'Sprites/Platforms_2.png', 'Sprites/Platforms_2.png.meta');
        this.load.unityAtlas('Platforms_3', 'Sprites/Platforms_3.png', 'Sprites/Platforms_3.png.meta');
        this.load.unityAtlas('PowerUps', 'Sprites/PowerUps.png', 'Sprites/PowerUps.png.meta');
        this.load.unityAtlas('RubixCube', 'Sprites/RubixCube.png', 'Sprites/RubixCube.png.meta');
        this.load.unityAtlas('ScoreBoard', 'Sprites/ScoreBoard.png', 'Sprites/ScoreBoard.png.meta');
        this.load.unityAtlas('smoke', 'Sprites/smoke.png', 'Sprites/smoke.png.meta');
        this.load.image('taptodrop', 'Sprites/taptodrop.png');
        this.load.image('closeButton', 'Sprites/closeButton.png');
        this.load.image('panel', 'Sprites/closeButton.png');
        this.load.unityAtlas('UI_New', 'Sprites/UI_New.png', 'Sprites/UI_New.png.meta');
        this.load.unityAtlas('Ui', 'Sprites/Ui.png', 'Sprites/Ui.png.meta');
        this.load.unityAtlas('Ui_4', 'Sprites/Ui_4.png', 'Sprites/Ui_4.png.meta');
        this.load.unityAtlas('warning', 'Sprites/warning.png', 'Sprites/warning.png.meta');
        this.load.image('get-stars', 'Sprites/get-stars.png');
        this.load.image('lock-icon', 'Sprites/lock-icon.png');

        this.load.image('howtoplay1', 'Sprites/howtoplay/howtoplay1.png');
        this.load.image('howtoplay2', 'Sprites/howtoplay/howtoplay2.png');
        this.load.image('howtoplay3', 'Sprites/howtoplay/howtoplay3.png');
        this.load.image('howtoplay4', 'Sprites/howtoplay/howtoplay4.png');

        this.load.image('fbinstant_share', 'fbinstant/share.png');
        this.load.image('fbinstant_shareButton', 'fbinstant/share-button.png');
        this.load.image('fbinstant_inviteButton', 'fbinstant/invite-button.png');
        this.load.image('fbinstant_tournamentButton', 'fbinstant/tournament-button.png');
        this.load.image('fbinstant_tournamentPlayerBanner', 'fbinstant/player-panel.png');
        this.load.image('fbinstant_tournamentListBanner', 'fbinstant/list-panel.png');
    }

    private loadAudio() {
        this.load.audio('bgm', 'Audio/bgm.mp3');
        this.load.audio('Drop', 'Audio/Score_swap.mp3');
        this.load.audio('Star', 'Audio/coin_collect.mp3');
        this.load.audio('Power Up', 'Audio/drop_item.mp3');
        // this.load.audio('Win', 'Audio/achievement_chime.mp3');
        this.load.audio('Fall', 'Audio/DM-CGS-22.mp3');
        // this.load.audio('Unlock', 'Audio/Complete.mp3');
        this.load.audio('Click', 'Audio/DM-CGS-21.mp3');
        this.load.audio('Explosion', 'Audio/explosion_2.mp3');
        this.load.audio('Laser', 'Audio/Laser.mp3');
    }

    create() {
        App.maxLives = this.getLives();
        App.lives = App.maxLives;
        App.MUTE = false;

        App.BGM = this.sound.add('bgm');

        // this.scene.launch('MainMenu');
        Game.instance.proceedLoadStage();

        var reference = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'none')
        reference.visible = false;

        this.cameras.main.setBackgroundColor('EAE8FF');
        this.cameras.main.startFollow(reference);

        this.resize(this.scale.gameSize);

        this.game.events.on('onPauseButton', () => { this.scene.pause() });
        this.game.events.on('onResumeButton', () => { this.scene.resume() });
        this.events.on('wake', this.onAwake.bind(this));
        this.events.emit('wake');
    }

    getLives() {
        return 3;
    }

    private onAwake(sceneData: any, data: any) {
        this.scene.wake('MainMenu');
    }

    private onCompletedContinue() {
        this.scene.sleep('Game');
        this.scene.sleep('MainMenu');
        this.scene.wake('Objective');
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }

    private loadStage: number = 0;
    public proceedLoadStage() {
        console.log("Load Stage A:", this.loadStage);
        if (this.loadStage < 2) {
            this.loadStage++;
            if (this.loadStage == 2) {
                this.loadStage++;
                this.time.delayedCall(3000, () => {
                    this.loadingScreen.classList.add('hide');
                    this.scene.launch('MainMenu');
                });
                // App.FBInstant.initializeFBInstant();
            }
        }
        console.log("Load Stage B:", this.loadStage);
    }
}


export enum Events {
    OnGameOver = 'onGameOver',
    OnRestart = 'onRestart'
}

